export function getView(letter) {
  if (letter.is_finalized) {
    return 'Final'
  }

  if (letter.task_id || letter.document_node_id) {
    return 'Draft'
  }

  return 'NeedsAction'
}
